import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { Action, CloseLight } from 'esa-ui-library';
import { useStore } from '../../../../../common';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import { cloneDeep, find } from 'lodash';
import { PropertyType } from 'esa-ui-library/lib/types';
import useFilters from '../../../../../common/hooks/useFilters';

const RolesFilter = (): JSX.Element => {
	const [{ roles, filters }] = useStore();
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, filterOptions);
		const filterValue = getFilterValue(updateOptions);

		onFilter([{ name: 'roles', value: filterValue }]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();

		onFilter([{ name: 'roles', value: '' }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		if (roles) {
			setFiltersOptions(cloneDeep(roles));
		}
	}, [roles]);

	useEffect(() => {
		const filter = find(filters, ['name', 'roles'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(roles, filter));
	}, [filters]);

	return (
		<Action
			label='Roles'
			labelContent={getLabelContent()}
			select
			className={`${filtersStyles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
			dataId='roles-filter'
		>
			<FilterDropdown data={filterOptions} onChange={onFilterChange} isSearchable />
		</Action>
	);
};

export { RolesFilter };
